interface IAccount {
  login: string;
  password: string;
}

export function getToastMsg(account: IAccount | null, orgCode: string, isEdit: boolean) {
  let msg;
  let timeout;

  if (account) {
    msg = `
      <div>开户成功，开户账号信息如下：</div>
      <div id="selectable">
        <div>组织编码：${orgCode}</div>
        <div>初始账号：${account.login}</div>
        <div>初始密码：${account.password}</div>
      </div>
      <div>请妥善保管以上信息，建议登录后修改密码</div>
      <a class="white--text" href="javascript:;" onclick="
        const selectable = document.getElementById('selectable');
        const selection = window.getSelection();
        if (selection.rangeCount > 0) {
          selection.removeAllRanges();
        }
        const range = document.createRange();
        range.selectNode(selectable);
        selection.addRange(range);
        document.execCommand('copy', false, null);
      ">点击复制账号信息</a>
    `;
    timeout = 0;
  } else {
    msg = isEdit ? '编辑成功' : '添加成功';
    timeout = 2000;
  }
  return { msg, timeout };
}
